// MathJax Configuration and Initialization
// Using node_modules version of MathJax

window.MathJax = {
  tex: {
    inlineMath: [['$', '$'], ['\\(', '\\)']],
    displayMath: [['$$', '$$'], ['\\[', '\\]']],
    processEscapes: true
  },
  svg: {
    fontCache: 'global'
  },
  startup: {
    ready: () => {
      MathJax.startup.defaultReady();
      // Typeset the page once MathJax is ready, then re-scroll to anchor
      MathJax.startup.promise.then(() => {
        MathJax.typesetPromise().then(() => {
          if (window.location.hash) {
            const target = document.querySelector(window.location.hash);
            if (target) {
              target.scrollIntoView();
            }
          }
        });
      });
    }
  }
};

// Import MathJax from node_modules (dynamic import for code splitting)
// SVG output renders math as paths, no external font files needed
import('mathjax/es5/tex-svg.js');
